import dayjs from 'dayjs'
import { useState } from 'react'
import useInterval from './useInterval'

export function useCurrentTime() {
  const [currentTime, setCurrentTime] = useState(dayjs())

  useInterval(() => {
    setCurrentTime(dayjs())
  }, 60000)

  return currentTime
}
